module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Introduction ")])]), _c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("The Rival brand Crock-pot in avocado green, circa 1970, was the slow cooker I grew up\n                with. It was the appliance that revolutionized my mother’s kitchen as she raised two\n                children while working and attending college. Having dinner ready and waiting was a\n                boon to her then, and has remained so for me even today. ")]), _vm._v(" "), _c('p', [_vm._v("This countertop treasure has been there as an extra pot to hold side dishes warm for\n                parties, has made dinner while I carpooled to baseball games and ballet lessons, and\n                now provides portion-friendly dinners for just my husband and me. ")]), _vm._v(" "), _c('p', [_vm._v("I truly enjoy what I call “recreational cooking”—when I have music playing in the\n                background, my favorite retro apron tied on my waist, and lots of pots and pans\n                simmering, boiling, roasting, and baking, with my thoughts on the friends and family\n                that will gather at my table to share these dishes made with love. ")]), _vm._v(" "), _c('p', [_vm._v("What I find most challenging in the kitchen is putting a regular meal on the table\n                night after night. While raising my family, I was a master at meal planning and\n                always knew what we were having for dinner. Now with my nest empty, I’ve felt a\n                little lost. ")]), _vm._v(" "), _c('p', [_vm._v("One of the biggest transitions from cooking for my family to cooking for two has\n                occurred at the grocery store. Those “family packs” of chicken thighs still cackle\n                their siren call toward me from the meat case, and I must say I find it difficult to\n                resist. But honestly, why do I need ten chicken thighs? Even “regular”-sized\n                packages serve at least four people! ")]), _vm._v(" "), _c('p', [_vm._v("That’s when I realized that I could still purchase the regular pack, but instead of\n                making a full recipe of a dish that would yield leftovers, I could do two different\n                preparations, yielding two completely different flavors. Using slow cooker liner\n                bags as cooking bags, I could separate the two recipes to keep them from commingling\n                in the crock and thus produce what I’m calling "), _c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Double Dinners")])]), _vm._v(". Now you can cook two different meals in the same slow cooker at the same\n                time, yielding one dinner for tonight and a second meal for another night this week,\n                or wrap it to freeze for another time. Cook once, eat twice! Now there’s a real\n                time-saver! ")]), _vm._v(" "), _c('p', [_vm._v("So now you see why I think that every cook passes through one phase or another where\n                a slow cooker can be a lifesaver—or at least a sanity-saver! Whether you are a\n                newlywed, an empty nester, living in a small apartment, or cook in a place where the\n                slow cooker might be the only appliance available (vacation cabin, boat, or RV),\n                this book is for you. ")]), _vm._v(" "), _c('p', [_vm._v("The recipes do not call for browning or other additional preparation steps requiring\n                another appliance such and a stove, oven or microwave. Each recipe is designed for\n                two, with a little left over for lunch or perhaps a second light meal or a third\n                drop-in diner. All of the ingredients can be found in your local grocery store,\n                without an extra trip to a specialty store. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e102",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Slow Cooker Safety ")])]), _c('a', {
    attrs: {
      "id": "d0e102",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Read the manufacturer’s guide that came with your slow cooker. It contains\n                information unique to your appliance. Never use an extension cord to plug in a slow\n                cooker. The cord is purposefully short to prevent the appliance from accidentally\n                tipping over. ")]), _vm._v(" "), _c('p', [_vm._v("The outside of a slow cooker gets hot, so keep it away from children and pets,\n                low-hanging cabinets, and walls. ")]), _vm._v(" "), _c('p', [_vm._v("Do not wash a slow cooker insert until it has cooled "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("or the pot might crack")])]), _vm._v(". ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e102",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e113",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("How to Use this Book ")])]), _c('a', {
    attrs: {
      "id": "d0e113",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("First, obtain the slow cooker liner bags. They are essential to the success of the\n                recipes. At the present time, Reynolds brand is the most widely available, usually\n                found on the same grocery aisle as plastic bags and aluminum foil. Regency Wraps,\n                Inc., also makes liner bags, found online or at some specialty retailers. Reynolds\n                and Regency liners are BPA-free and approved by the FDA for cooking. ")]), _vm._v(" "), _c('p', [_vm._v("The recipes have been created in pairs (A’s and B’s) to make it easy on the cook.\n                Each pair calls for a common package size of chicken, beef, lamb, or pork to split\n                between two liner bags. Each A and B will have separate preparation directions, and\n                at the end of recipe B will be the cooking directions for cooking both bags in the\n                same slow cooker. ")]), _vm._v(" "), _c('p', [_vm._v("I’ve tested all of these recipes in my Cuisinart 3 1/2-quart slow cooker. A 4-quart\n                slow cooker is also a good size here. For a variety of slow cooker recipes for two,\n                including everything from the classic pot roasts, to Cornish hen, to side dishes of\n                potato gratin and ratatouille, see my previous book, "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Slow Cooking for Two: Basics, Techniques, Recipes")])]), _vm._v(" (Gibbs Smith, 2013). ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of open slow cooker with two liners."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of open slow cooker with two liners.",
      "src": "images/IMG_2988.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of lidded slow cooker with two liners."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of lidded slow cooker with two liners.",
      "src": "images/IMG_2986.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e113",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e134",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Why Slow Cooking? ")])]), _c('a', {
    attrs: {
      "id": "d0e134",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Slow cooking is an ideal cooking method to tenderize tough cuts of meat. It’s also a\n                boon to the busy cook who could benefit from a recipe that cooks unattended. A slow\n                cooker uses about the same amount of electricity as a 75-watt bulb. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e134",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e138",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("About Slow Cookers ")])]), _c('a', {
    attrs: {
      "id": "d0e138",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e138",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Selecting a Slow Cooker ")])]), _c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Slow cookers are available in many sizes, from just 1-quart all the way up to\n                7-quart. For a typical family, a 5- to 7-quart size is ideal, but it’s too large\n                when cooking for two. I’ve found the best size for me is the 3 1/2-quart slow\n                cooker. There are a few choices in that size range; I like one with these handy\n                features: ")]), _vm._v(" "), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("High, Low, Warm, and Off settings ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Programmable Timer ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Auto switch to Warm at the end of cooking time ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Power indicator light ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("See-through lid ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Removable crock ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Oval shape (more accommodating to irregular-shaped foods) ")])])])])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e166",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Important Recipe Tips ")])]), _c('a', {
    attrs: {
      "id": "d0e166",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("A common complaint about slow cooker recipes is that they all taste the same or look\n                the same. While it’s true that what a slow cooker does best is the long, slow\n                braise, which usually means a beef roast is involved, there are ingredients to\n                further jazz up your recipes. At the end of cooking, stir in any of the following: ")]), _vm._v(" "), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Additional chopped fresh herbs ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Grated lemon or lime rind ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("A little extra garlic ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("A dash of soy sauce, sriracha, pesto, or other ready-made sauce ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("A dollop of tomato paste ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("A bit of chopped cooked bacon ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("A little extra grated cheese, usually Parmesan ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Seasonings to taste, especially more salt and pepper ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of seasonings."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of seasonings.",
      "src": "images/SCDD_00.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of herbs."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of herbs.",
      "src": "images/SCDD_01.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Don’t lift the lid during cooking unless directed by the recipe, or you’ll need to\n                add 20 minutes to the cooking time. ")]), _vm._v(" "), _c('p', [_vm._v("Dense root vegetables, like potatoes, cook more slowly than meat in the slow cooker,\n                so put them in the cooker first, on the bottom and closest to the heat. ")]), _vm._v(" "), _c('p', [_vm._v("Don’t fill slow cookers to the top. They cook most efficiently when they are half to\n                three-quarters full. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e166",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e211",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cooking Times ")])]), _c('a', {
    attrs: {
      "id": "d0e211",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Different slow cookers vary in their temperature range. Most reach a temperature of\n                300 degrees on High, and 200 degrees on Low. Some cook fast (at a higher\n                temperature) and some cook slow (at a lower temperature). You’ll have to adjust\n                cooking times to the quirks of your slow cooker. This can be a little frustrating at\n                first, so allow some flexibility in the finishing time of a recipe the first time\n                you make it—it might be ready a little earlier—or a bit later—than expected. Once\n                you know how your slow cooker operates, you’ll be able to adjust the recipe cooking\n                times accordingly. ")]), _vm._v(" "), _c('p', [_vm._v("Read the recipe all the way through before cooking, and assemble all ingredients. If\n                you are transporting your dish to serve at a different location, plan to use a liner\n                so you can tie the liner closed before transporting the meal in the slow cooker,\n                thus precluding a nasty spill. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e211",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e217",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Favorite Non-Slow Cooker Recipes ")])]), _c('a', {
    attrs: {
      "id": "d0e217",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Here’s a handy chart for converting your non-slow cooker recipes. ")]), _vm._v(" "), _c('div', {
    staticClass: "informaltable"
  }, [_c('table', {
    attrs: {
      "border": "1"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Conventional Recipe Time")])]), _vm._v(" "), _c('td', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Slow Cooker Time on LOW")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("15 minutes")]), _vm._v(" "), _c('td', [_vm._v("1 1/2 to 2 hours")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20 minutes")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 hours")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("30 minutes")]), _vm._v(" "), _c('td', [_vm._v("3 to 4 hours")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("45 minutes")]), _vm._v(" "), _c('td', [_vm._v("5 to 6 hours")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("60 minutes")]), _vm._v(" "), _c('td', [_vm._v("6 to 8 hours")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("90 minutes")]), _vm._v(" "), _c('td', [_vm._v("8 to 9 hours")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 hours")]), _vm._v(" "), _c('td', [_vm._v("9 to 10 hours")])])])])]), _vm._v(" "), _c('p', [_vm._v("A recipe that is normally braised on the stove or in the oven is a good candidate for\n                the slow cooker. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e217",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e266",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Frequently Asked Questions ")])]), _c('a', {
    attrs: {
      "id": "d0e266",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e266",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e268",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Do I have to check on the slow\n                cooker while it’s cooking? ")])]), _c('a', {
    attrs: {
      "id": "d0e268",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("The first time you use your slow cooker, plan to be home. That way you’ll be there to\n                notice any quirks of your appliance. After that, you can leave the slow cooker to do\n                the work alone. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e268",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e272",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Do I have to stir? ")])]), _c('a', {
    attrs: {
      "id": "d0e272",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Luckily, stirring is not necessary during cooking, unless specifically indicated in\n                the recipe. In fact, lifting the lid to stir when it’s not indicated will increase\n                the cooking time by 20 minutes. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e272",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e276",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Does the slow cooker stop\n                automatically? ")])]), _c('a', {
    attrs: {
      "id": "d0e276",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Only if you have a programmable machine, which I highly recommend. Otherwise, set a\n                timer so you can be ready to turn your slow cooker to WARM or OFF. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e276",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e280",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("What if I overcook the recipe? ")])]), _c('a', {
    attrs: {
      "id": "d0e280",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("A slow cooker is very forgiving. Usually the cooking times are for a range of time,\n                so not to worry. The recipes in this book will specify if there is a danger of\n                overcooking. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e280",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e284",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("How long can a recipe sit in the\n                slow cooker? ")])]), _c('a', {
    attrs: {
      "id": "d0e284",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("The programmable slow cookers are set to turn automatically to the Warm setting after\n                cooking. They then switch to OFF after 2 hours. As a general rule, food should not\n                sit for more than 2 hours after cooking, or there is an increased risk of bacteria\n                growing. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e284",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e288",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Can I convert my own recipes to\n                the slow cooker? ")])]), _c('a', {
    attrs: {
      "id": "d0e288",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Yes, but primarily they should be recipes based on long, slow cooking on the stove or\n                in the oven, with liquid to help create steam. See the rough conversion chart on the\n                facing page. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e288",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e292",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Can I bake in my slow cooker? ")])]), _c('a', {
    attrs: {
      "id": "d0e292",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Yes! Check out the cake and bread recipes in my book "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Slow Cooking for Two: Basics, Techniques, Recipes")])]), _vm._v(". Experiment to come up with new recipes. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e292",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e299",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Can I mix and match these\n                recipes? ")])]), _c('a', {
    attrs: {
      "id": "d0e299",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Absolutely! You can cook chicken next to pork, or any combination you desire. The\n                only consideration is that the two dishes need to cook at the same temperature and\n                time. ")])]), _c('h5', [_c('a', {
    attrs: {
      "id": "d0e299",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e303",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Can I double just one recipe? ")])]), _c('a', {
    attrs: {
      "id": "d0e303",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("That’s a great idea. For example, if you want to prepare the whole chuck roast (both\n                halves), follow the recipe for your favorite version and double everything EXCEPT\n                the liquid—add only 50 percent more. For instance, if the recipe calls for 1 cup of\n                broth, when doubling add just 1 1/2 cups broth, not 2 cups. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e303",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e307",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Slow Cooker Pantry ")])]), _c('a', {
    attrs: {
      "id": "d0e307",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("I’m a firm believer in a well-stocked pantry. It’s especially handy when life gets in\n                the way of my plans. The recipes in this book are based on pantry staples, ensuring\n                you’ll have the ingredients on hand. ")])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e307",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e311",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Refrigerator ")])]), _c('a', {
    attrs: {
      "id": "d0e311",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Dairy")])]), _vm._v("—butter, milk, half-and-half or heavy cream, and a variety of\n                            cheeses (blocks to freshly grate, or already grated or shredded).\n                            Parmigiano-Reggiano is the king of all Parmesan cheese, and its\n                            extraordinary taste is well worth the extra expense. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Vegetables")])]), _vm._v("—a variety of fresh herbs (basil, chives, cilantro, oregano,\n                            parsley, rosemary, tarragon, thyme), carrots, celery, bell peppers, hot\n                            peppers, eggplant, ginger, kale, spinach, leeks, lemons, limes,\n                            mushrooms, zucchini ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Condiments")])]), _vm._v("—ketchup, Worcestershire sauce, soy sauce, Dijon and spicy brown\n                            mustard, hoisin sauce, favorite hot sauce, salsa, horseradish ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Fully-cooked bacon")])])])])])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e311",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e335",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dry Pantry ")])]), _c('a', {
    attrs: {
      "id": "d0e335",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Garlic, shallots, and onions ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Russet, red, new, and sweet potatoes ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Canned tomatoes in a variety of preparations—whole, crushed, diced,\n                            tomato sauce ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Marinated artichoke hearts ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Dried fruits and tomatoes ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Flour (all-purpose and self-rising), cornstarch, and/or quick-cooking\n                            tapioca for thickening sauces ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Brown and white sugars, honey ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Breadcrumbs ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Broths—chicken, beef, vegetable ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Red and white wine, dry sherry, port ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Vinegars—white, red wine, balsamic ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Oils—olive oil, other cooking oil ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Chipotle chile in adobo, canned green chiles ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Uncooked converted rice ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Dried lentils ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Canned black beans, cannellini beans, kidney beans ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Peanut butter ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Nuts—almonds, pecans, walnuts ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Capers, olives ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Jams and jellies ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Spices—allspice, bay leaf, chili powder, Chinese five-spice powder,\n                            ground cinnamon, ground cloves, ground coriander, ground cumin, Italian\n                            seasoning, ground nutmeg, ground sage, red pepper flakes ")])])])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e335",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e401",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Freezer ")])]), _c('a', {
    attrs: {
      "id": "d0e401",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Vegetables—corn, chopped onion, herbs ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Meats—flank steak, chuck roast, sirloin tip, bottom round, eye of the\n                            round, short ribs, pork tenderloin, beef and lamb stew meat, pork\n                            tenderloin, pork chops ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Poultry—boneless, skinless chicken breasts; skinless chicken thighs;\n                            boneless, skinless chicken thighs; turkey tenderloins")])])])])])]), _c('a', {
    attrs: {
      "id": "d0e401",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0